export default {"src":"/_next/static/media/mastercard.a6009c2e.svg","height":24,"width":34,"blurWidth":0,"blurHeight":0};